import { SWReactIcons } from "@similarweb/icons";

import { translate } from "app/filters/i18nFilter";

import { StyledAiFilterModeButton } from "./styles";
import type { FilterModeButtonProps } from "./types";

export const AiFilterModeButton = ({ isSelected, label, onClick }: FilterModeButtonProps) => {
    return (
        <StyledAiFilterModeButton
            variant={isSelected ? "ghost" : "flat"}
            icon={
                <SWReactIcons
                    iconName="sparkles-ai"
                    size="xs"
                />
            }
            label={label ?? translate("si.filter-panel.mode.ai.trigger.title")}
            withPointerEvents={!isSelected}
            onClick={onClick as VoidFunction}
        />
    );
};
